import { render, staticRenderFns } from "./SearchNavStartEnd.vue?vue&type=template&id=3b5b27dd&scoped=true"
import script from "./SearchNavStartEnd.vue?vue&type=script&lang=js"
export * from "./SearchNavStartEnd.vue?vue&type=script&lang=js"
import style0 from "./SearchNavStartEnd.vue?vue&type=style&index=0&id=3b5b27dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5b27dd",
  null
  
)

export default component.exports